module.exports = __webpack_public_path__ + "img/video_line.4604df1d.svg";